import React from "react";
import { TButtonProps } from "types/Components/Common/Button";

const FillButton = ({
  type = "button",
  border = "2",
  buttonStyle = "primary",
  id = "",
  onClick,
  disabled = false,
  className,
  disabledClassName = "!tw-border-ink-disabled !tw-bg-ink-disabled",
  children,
  color,
  "data-testid": dataTestId,
}: TButtonProps) => {
  let _className = "!tw-border-accent-bold !tw-bg-accent-bold hover:!tw-bg-accent-bold-hover hover:!tw-border-accent-bold-hover"

  if(buttonStyle === "danger") _className = "!tw-border-tone-danger-bold !tw-bg-tone-danger-bold hover:!tw-bg-tone-danger-bold-hover hover:!tw-border-tone-danger-bold-hover"

  return (
    <div>
      <button
        type={type}
        id={id}
        data-testid={dataTestId}
        onClick={onClick}
        disabled={disabled}
        className={` ${disabled && disabledClassName} ${_className}
        tw-border rounded  tw-box-border
        tw-cursor-pointer tw-inline-block tw-font-noto-sans tw-text-sm
        tw-leading-5 tw-min-h-[36px] tw-m-0 focus:tw-outline-none tw-p-2 tw-py-1 !tw-min-w-[92px]
        tw-relative tw-text-center tw-no-underline tw-touch-manipulation tw-select-none tw-font-normal !tw-text-ink-inverse`}
      >
        {children}
      </button>
    </div>
  );
};


export default FillButton;
